export default __webpack_public_path__ + "1a1cc0a.png";